<template>
	<div class="col-12 mt-5 p-3">
		<div class="element-box less-padding" v-if="visitor">
			<h6 class="element-box-header text-center">
				{{ t.navigation.unique_visitors }}
			</h6>
			<div class="el-chart-w">
				<canvas height="120" ref="visitorChart" id="donutChart1" width="120"></canvas>
				<div class="inside-donut-chart-label">
					<strong>{{ visitor.total | nK }}</strong><span>{{ t.navigation.amount_of_online }}</span>
				</div>
			</div>
			<div class="el-legend condensed">
				<div class="row">
					<div class="col-auto col-xxxxl-6 ml-sm-auto mr-sm-auto">
						<div class="legend-value-w">
							<div class="legend-pin legend-pin-squared" style="background-color: #6896f9;"></div>
							<div class="legend-value">
								<span>{{ visitor.guest | nK }}</span>
								<div class="legend-sub-value">
									{{ t.navigation.guest }}
								</div>
							</div>
						</div>
						<div class="legend-value-w">
							<div class="legend-pin legend-pin-squared" style="background-color: #85c751;"></div>
							<div class="legend-value">
								<span>{{ visitor.users | nK }}</span>
								<div class="legend-sub-value">
									{{ t.users }}
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 d-none d-xxxxl-block">
						<div class="legend-value-w">
							<div class="legend-pin legend-pin-squared" style="background-color: #806ef9;"></div>
							<div class="legend-value">
								<span>{{ visitor.clients }}</span>
								<div class="legend-sub-value">
									{{ t.navigation.client }}
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import formatter from '@/mixins/formatter'

    export default {
        name: "onlineUsers",
        mixins: [formatter],
        data () {
            return {
                t: this.$root.t,
                visitor: null
            }
        },
        mounted () {
            this.fetchStats();
            setInterval(() => {
                this.fetchStats();
            }, 10000);
        },
	    methods: {
            onlineChart () {

                var donutChart1 = document.getElementById("donutChart1");

                // donut chart data
                var data1 = {
                    labels: [this.t.navigation.guest, this.t.navigation.client, this.t.users ],
                    datasets: [{
                        data: [this.visitor.guest, this.visitor.clients, this.visitor.users],
                        backgroundColor: ["#5797fc", "#7e6fff", "#4ecc48", "#ffcc29",],
                        hoverBackgroundColor: ["#5797fc", "#7e6fff", "#4ecc48", "#ffcc29"],
                        borderWidth: 2,
                        hoverBorderColor: 'transparent'
                    }]
                };

                // -----------------
                // init donut chart
                // -----------------
                new Chart(donutChart1, {
                    type: 'doughnut',
                    data: data1,
                    options: {
                        legend: {
                            display: false
                        },
                        animation: {
                            animateScale: true
                        },
                        cutoutPercentage: 80
                    }
                });
            },
            fetchStats () {
                this.$http.get(api+'api/v1/analytics/active/sessions', {params: {period: this.selectedAccountingPeriod, noCache: 1}}).then(response => {
                    // get body data
                this.visitor = response.body.result.visitor;

                var th = this;
                setTimeout(function(){
                    th.onlineChart()
                }, 1000);
            }, response => {

                })
            }
	    }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/user/widget/online.vue